import { useContext, useState } from 'react';
import { TextsContext } from '../context/textsContext';
import { Icon } from '@iconify/react';
import DropdownComponent from './DropdownComponent';
import style from '../scss/dropdown.module.scss';

const LANGUAGES = [
  { value: 'es', label: 'Español', flag: 'twemoji:flag-spain' },
  { value: 'en', label: 'English', flag: 'twemoji:flag-england' },
  { value: 'pt', label: 'Português', flag: 'twemoji:flag-portugal' },
];

const LanguageDropdown = () => {
  const { updateTexts, getCurrentLanguage } = useContext(TextsContext);
  const [selected, setSelected] = useState(
    () => LANGUAGES.find((l) => l.value === getCurrentLanguage()) ?? LANGUAGES[0]
  );

  const handleSelect = (item) => {
    setSelected(item);
    updateTexts(item.value);
  };

  return (
    <DropdownComponent
      trigger={
        <div className={style.languageTrigger}>
          <Icon icon={selected.flag} className={style.flagIcon} />
          <span className="d-none d-lg-inline">{selected.label}</span>
        </div>
      }
      items={LANGUAGES}
      renderItem={(item) => (
        <div className={style.languageItem}>
          <Icon icon={item.flag} className={style.flagIcon} />
          <span>{item.label}</span>
        </div>
      )}
      onSelect={handleSelect}
    />
  );
};

export default LanguageDropdown;
